import type { Quaternion, Vector3 } from 'three';

/** Shared avatar/creature eye rotation. Axes are expressed in the gaze bone's
 * rest frame. Yaw is character-right positive; pitch is up positive. */
export function composeEyeLook(
  out: Quaternion, pitchScratch: Quaternion, up: Vector3, right: Vector3,
  yaw: number, pitch: number,
): Quaternion {
  out.setFromAxisAngle(up, -yaw);
  pitchScratch.setFromAxisAngle(right, pitch);
  return out.multiply(pitchScratch);
}
